import React from 'react';
import { Link } from 'react-router';
import { useUser, useAuth } from '@/providers';

import {
  styled,
  useTheme,
  IconButton,
  Box,
  useMediaQuery,
} from '@mui/material';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import PushPinIcon from '@mui/icons-material/PushPin';
import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined';

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  padding: theme.spacing(0, 2),
  justifyContent: 'space-between',
  backgroundColor: theme.palette.brandBlack.main,
}));

function SidebarHeader({ toggleDrawer, pinned, togglePin }) {
  const theme = useTheme();
  const is_mobile = useMediaQuery(theme.breakpoints.down('md'));
  const user = useUser();
  const session = useAuth();

  const logoLink = () => {
    if (session && session.isLoggedIn && user) {
      if (user.status === 'approved') {
        return '/dashboard';
      }
    }
    return '/';
  };

  return (
    <DrawerHeader>
      <Box
        component={Link}
        to={logoLink()}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flex: 1,
          textDecoration: 'none',
        }}
      >
        <Box
          component='img'
          src='/logo.png'
          alt={import.meta.env.VITE_ORG_NAME}
          sx={{
            maxWidth: '100%',
            height: 'auto',
            maxHeight: '40px',
          }}
        />
      </Box>
      {!is_mobile && (
        <IconButton
          onClick={togglePin}
          sx={{ color: theme.palette.brandBlack.contrastText }}
          title={pinned ? 'Unpin sidebar' : 'Pin sidebar'}
        >
          {pinned ? <PushPinIcon /> : <PushPinOutlinedIcon />}
        </IconButton>
      )}
      {!pinned && (
        <IconButton
          onClick={toggleDrawer}
          sx={{ color: theme.palette.brandBlack.contrastText }}
        >
          {theme.direction === 'ltr' ? (
            <ChevronLeftIcon />
          ) : (
            <ChevronRightIcon />
          )}
        </IconButton>
      )}
    </DrawerHeader>
  );
}

export default SidebarHeader;
